import { VStack } from 'tio-ui/components/layout';
import GuidedWizard from 'tio-employee/components/tas/applications/guided/wizard';
import type { TOC } from '@ember/component/template-only';
import type TasApplicationModel from 'tio-common/models/tas-application';
import type TASProgramInstanceModel from 'tio-common/models/tas-program-instance';

export interface S {
  Args: {
    model: {
      application: TasApplicationModel;
      programInstance: TASProgramInstanceModel;
    };
  };
}

const tmpl: TOC<S> = <template>
  <VStack>
    <GuidedWizard @model={{@model}} />
  </VStack>
</template>;

export default tmpl;
